<template>
  <div>
    <header-info cur="1"></header-info>
    <div
      id="center"
      style="min-height: 158px;"
    >
      <div
        id="content"
        class="content"
      >

        <div
          class="center_content container"
          style="visibility: visible;"
        >
          <div class="mbox-wrap hidebox">
            <div class="mbox mw clearfix">
              <div class="video-wrap">
                <div
                  class="btns-wrap"
                  id="videoBtns"
                >
                  <button
                    :class="videoActive==1?'on':''"
                    @click="videoActive=1"
                  >教学引导视频
                  </button>
                  <button
                    :class="videoActive==2?'on':''"
                    @click="videoActive=2"
                  >项目简介视频
                  </button>
                </div>
                <video
                  :src="(videoActive==1? formatVideoPath(formInfo.tech_video, formInfo.tech_resource): formatVideoPath(formInfo.brief_video, formInfo.brief_resource))"
                  :poster="formInfo.logo.substr(1,formInfo.logo.length)"
                  controls=""
                >您的浏览器不支持Video标签
                </video>
              </div>
              <div class="detail-wrap">
                <p class="p1">{{ formInfo.title }}
                <p class="p2"><span>学院：{{ formInfo.academy ? formInfo.academy.title : '' }}</span>
                  <span>对应专业大类：{{ formInfo.subject ? formInfo.subject.subject_category.title : '' }}</span>
                  <span>对应专业：{{ formInfo.subject ? formInfo.subject.title : '' }}</span>
                </p>
                <p class="p2"><span>负责人教师：{{ formInfo.master_name ? formInfo.master_name : '' }}</span>
                  <span>申报级别：{{ formInfo.exp_level ? formatExpLevel(formInfo.exp_level) : '--' }}</span>
                  <span>实验已开设期次：{{ formInfo.open_times ? formInfo.open_times : '--' }}</span>
                </p>
                <p class="p2"><span>实验类型：{{
                    formInfo.exp_type ? $store.state.dict_exp_type[formInfo.exp_type] : '--'
                  }}</span>
                  <span>实验语言：{{
                      formInfo.exp_language ? $store.state.dict_exp_language[formInfo.exp_language] : '--'
                    }}</span>
                </p>
                <p class="p2">
                  <span>虚拟仿真必要性：
                    <span
                      v-if="formInfo.necessity && formInfo.necessity.Obj1"
                      style="margin-right:10px"
                    >高危或极端环境 </span>
                    <span
                      v-if="formInfo.necessity && formInfo.necessity.Obj2"
                      style="margin-right:10px"
                    >高成本、高消耗 </span>
                    <span
                      v-if="formInfo.necessity && formInfo.necessity.Obj3"
                      style="margin-right:10px"
                    >不可逆操作</span>
                    <span v-if="formInfo.necessity && formInfo.necessity.Obj4">大型综合训练</span>
                    <span v-if="formInfo.necessity && formInfo.necessity.Obj1 =='' && formInfo.necessity.Obj2=='' && formInfo.necessity.Obj3==''">-</span>
                  </span>
                </p>
                <div
                  class="detail-intro"
                  style="margin-top: 10px;"
                ><span class="label">实验简介：</span>{{ formInfo.brief }}
                </div>
                <div class="btns-wrap">
                  <button
                    class="btn-join"
                    v-if="audit_status===0"
                  >申请中
                  </button>
                  <button
                    class="btn-join"
                    v-else
                    @click="addPerson"
                  >开始实验
                  </button>
                  <button
                    :class="collectInfo?'btn-join':'btn-collect'"
                    data="1"
                    @click="toCollect"
                  >
                    <i class="icon iconfont">&#xe66b;</i>收藏
                  </button>
                  <button
                    v-if="parseInt(localUser.role) <= 3 || formInfo.master_id == localUser.profile_id"
                    class="btn-join btn-view"
                    @click="toViewScore"
                  >成绩查看
                  </button>
                </div>
                <div class="btns-wrap ">
                  <button
                    class="btn-evaluate"
                    @click="showCommentWindow"
                  >
                    <i class="icon iconfont">&#xe664;</i>实验评价
                  </button>
                  <div class="star-wrap">
                    <i
                      class="icon iconfont"
                      v-for="(term,i) in 5"
                      :key="i"
                    >
                      {{ formInfo.appraise_avg > i ? '&#xe67f;' : '&#xe66b;' }}
                    </i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-wrap info-box mw hidebox">
            <div class="menu-box">
              <ul class="menu-list clearfix">
                <li
                  :class="menuSelected == '/www/experiment/team' ? 'on' : ''"
                  class="hidebox"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/www/experiment/team?id=' + params.id">实验团队</router-link>
                </li>
                <li
                  :class="menuSelected == '/www/experiment/des' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/www/experiment/des?id=' + params.id">实验描述</router-link>
                </li>
                <li
                  :class="menuSelected == '/www/experiment/support' ? 'on' : ''"
                  class="hidebox"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/www/experiment/support?id=' + params.id">支持与服务</router-link>
                </li>
                <li
                  :class="menuSelected == '/www/experiment/net' ? 'on' : ''"
                  class="hidebox"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/www/experiment/net?id=' + params.id">网络要求</router-link>
                </li>
                <li
                  :class="menuSelected == '/www/experiment/frame' ? 'on' : ''"
                  class="hidebox"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/www/experiment/frame?id=' + params.id">技术架构</router-link>
                </li>
                <li
                  :class="menuSelected == '/www/experiment/service_plan' ? 'on' : ''"
                  class="hidebox"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/www/experiment/service_plan?id=' + params.id">服务计划</router-link>
                </li>
                <li
                  :class="menuSelected == '/www/experiment/feature' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/www/experiment/feature?id=' + params.id">实验特色</router-link>
                </li>
                <li
                  :class="menuSelected == '/www/experiment/intel' ? 'on' : ''"
                  class="hidebox"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/www/experiment/intel?id=' + params.id">知识产权</router-link>
                </li>
                <li
                  :class="menuSelected == '/www/experiment/promise' ? 'on' : ''"
                  class="hidebox"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/www/experiment/promise?id=' + params.id">诚信承诺</router-link>
                </li>
                <li
                  :class="menuSelected == '/www/experiment/material' ? 'on' : ''"
                  class="hidebox"
                  @click="updateMenuSelected"
                >
                  <router-link :to="'/www/experiment/material?id=' + params.id">附件材料</router-link>
                </li>
              </ul>
            </div>
            <div class="part">
              <router-view
                :isShow="isShow"
                :expId="$route.query.id"
              ></router-view>
            </div>
          </div>
        </div>
        <div
          class="form_overlay"
          id="form_overlay"
          :style="classCommentWindow"
        >
          <div class="form_overlay_bg"></div>
          <div class="form_panel">
            <div
              class="form_title"
              style="padding-left: 13px;"
            >实验评价
              <span
                class="close-overlay"
                @click="hideCommentWindow"
              ></span>
            </div>
            <div class="form_content">
              <div
                class="score-wrap"
                id="scoreWrap"
              >
                <div class="score-detail">
                  <p class="score-text pull-left">{{ formInfo.appraise_avg ? formInfo.appraise_avg : '0' }}</p>
                  <div class="pull-left">
                    <div class="star-wrap">
                      <i
                        class="iconfont"
                        v-for="(term,i) in 5"
                        :key="i"
                      >
                        {{ formInfo.appraise_avg > i ? '&#xe67f;' : '&#xe66b;' }}
                      </i>
                    </div>
                  </div>
                </div>
                <button
                  :class="commentType?'btn-publish-evaluate':'btn-publish-bg'"
                  @click="showDiscussWindow"
                >评分
                </button>

              </div>
            </div>
          </div>
        </div>

        <div
          class="form_overlay"
          id="pub_form_overlay"
          :style="classDiscussWindow"
        >
          <div class="form_overlay_bg"></div>
          <div class="form_panel">
            <div class="form_title">评分
              <span
                class="close-overlay"
                @click="hideDiscussWindow"
              ></span>
            </div>
            <div class="form_content">
              <form id="itemForm">
                <div class="item">
                  <span class="label"><i class="require">*</i>我的评分:</span>
                  <div
                    class="check-star"
                    id="checkStar"
                  >
                    <span
                      class="star"
                      v-for="(item,index) in 5"
                      :key="index"
                      :class="star>index?'checked':''"
                      @mouseover="hoverStars(index)"
                    >
                      <i class="iconfont yes">&#xe67f;</i>
                      <i class="iconfont no">&#xe66b;</i>
                    </span>
                    <span class="scoreText">{{ commentInfo.grade }}分</span>
                  </div>
                </div>

              </form>
            </div>
            <div class="form_control">
              <a
                href="javascript:;"
                class="button close"
                id="form_close"
                @click="hideDiscussWindow"
              >取消</a>
              <a
                href="javascript:;"
                class="button"
                id="form_submit"
                @click="toComment"
              >提交</a>
            </div>
          </div>
        </div>
        <div
          class="form_overlay"
          :style="classShowGradeWindow"
        >
          <div class="form_overlay_bg"></div>
          <div class="form_panel form_panel_item">
            <div class="form_title">
              <span @click="classShowGradeWindow={}"></span>
            </div>
            <div class="form_content">
              <div class="f_list">
                <table>
                  <tbody>
                    <tr class="l_header">
                      <th class="itemStatus">用户名</th>
                      <th class="itemStatus">姓名</th>
                      <th class="itemStatus">实验结果</th>
                      <th class="itemStatus">实验成绩</th>
                      <th class="itemStatus">实验开始时间</th>
                      <th class="itemStatus">实验结束时间</th>
                      <th class="itemStatus">实验用时</th>
                      <th
                        class="action"
                        width="130"
                      >操作
                      </th>
                    </tr>
                    <tr
                      v-for="item in gradeTableData"
                      :key="item.id"
                    >
                      <td class="itemStatus">{{ item.experimentStudent.userprofile.username }}</td>
                      <td class="itemStatus">{{ item.experimentStudent.userprofile.name }}</td>
                      <td class="itemStatus">{{ item.status ? '完成' : '未完成' }}</td>
                      <td class="itemStatus">{{ item.score }}</td>
                      <td class="itemStatus">{{ item.startTime.replace('T', ' ') }}</td>
                      <td class="itemStatus">{{ item.endTime.replace('T', ' ') }}</td>
                      <td class="itemStatus">{{ item.timeUsed }}</td>
                      <td class="action">
                        <a
                          class="edit"
                          href="javascript:;"
                          @click="viewDetail(item)"
                        >查看详情</a>
                      </td>
                    </tr>
                    <tr
                      class="noitems"
                      v-if="!gradeTableData.length"
                    >
                      <td colspan="7">没有数据</td>
                    </tr>
                  </tbody>

                </table>

              </div>
              <!-- 分页 -->
              <pagination
                :cur='pageGradeInfo.page'
                :all='pageGradeInfo.all'
                :totalData="pageGradeInfo.totalData"
                :callback="pageGradeCallback"
              ></pagination>
            </div>
          </div>
        </div>
        <div
          class="form_overlay"
          :style="classShowDetailWindow"
        >
          <div class="form_overlay_bg"></div>
          <div class="form_panel form_panel_item">
            <div class="form_title">详情
              <span @click="classShowDetailWindow={}">X</span>
            </div>
            <div class="form_content">
              <div class="experiment_text">
                <p>姓名：{{ experimentGrade && experimentGrade.experimentStudent ? experimentGrade.experimentStudent.userprofile.name : '' }}</p>
                <p><span>实验开始时间：{{ experimentGrade.startTime }}</span>
                  <span>实验结束时间：{{ experimentGrade.endTime }}</span>
                  <span>实验用时：{{ experimentGrade.timeUsed }}</span>
                </p>
                <p><span>实验满分：100</span>
                  <span>实验得分：{{ experimentGrade.score }}</span>
                  <span>实验结果：{{ experimentGrade.status ? '完成' : '未完成' }}</span>
                </p>
              </div>
              <div class="f_list">
                <table v-if="tableStepData.length">
                  <tbody>
                    <tr class="l_header">
                      <th class="itemStatus">步骤名称</th>
                      <th class="itemStatus">步骤开始时间</th>
                      <th class="itemStatus">步骤结束时间</th>
                      <th class="itemStatus">步骤用时(秒)</th>
                      <th class="itemStatus">步骤合理用时(秒)</th>
                      <th class="itemStatus">步骤满分</th>
                      <th class="itemStatus">步骤得分</th>
                      <th class="itemStatus">步骤操作次数</th>
                      <th class="itemStatus">步骤评价</th>
                      <th class="itemStatus">赋分模型</th>
                      <th class="itemStatus">备注</th>
                    </tr>
                    <tr
                      v-for="item in tableStepData"
                      :key="item.id"
                    >
                      <td class="itemStatus">{{ item.title }}</td>
                      <td class="itemStatus">{{ item.startTime.replace('T', ' ') }}</td>
                      <td class="itemStatus">{{ item.endTime.replace('T', ' ') }}</td>
                      <td class="itemStatus">{{ item.timeUsed }}</td>
                      <td class="itemStatus">{{ item.expectTime }}</td>
                      <td class="itemStatus">{{ item.maxScore }}</td>
                      <td class="itemStatus">{{ item.score }}</td>
                      <td class="itemStatus">{{ item.repeatCount }}</td>
                      <td class="itemStatus">{{ item.evaluation }}</td>
                      <td class="itemStatus">{{ item.scoringModel }}</td>
                      <td class="itemStatus">{{ item.remarks }}</td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="noitems"
                  v-else
                >没有数据
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div
      id="south"
      ref="south"
    >
      <footer-info></footer-info>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import Pagination from '../../../components/Pager'
import FooterInfo from '../../../components/FooterInfo'
import CryptoJs from 'crypto-js'

export default {
  name: 'Experiment',
  components: {
    HeaderInfo,
    Pagination,
    FooterInfo
  },
  data() {
    return {
      isShow: false,
      menuSelected: '',
      params: {
        id: 0,
        ticket: ''
      },
      mainData: [],
      otherData: [],
      commentData: [],
      commentDataCount: 0,
      active: 1,
      videoActive: 1,
      formInfo: {
        id: 0,
        academy_id: 0,
        appraise_avg: '',
        academy: null,
        subject_id: 0,
        subject: null,
        master_id: 0,
        master_name: null,
        title: '',

        url: '',
        isTeacherCheck: 0,
        exp_level: 0,
        duration: '',
        concurrence: '',
        brief: '',
        claim: '',
        logo: '',

        brief_video: '',
        tech_video: '',
        brief_resource: null,
        tech_resource: null,

        goal: '',

        theory: '',
        theory_content: '',
        theory_point: '',

        device: '',
        materials: '',
        tech_func: '',

        step_claim: '',
        step_claim_des: '',
        step_claim_step: '',
        step_claim_step_des: '',

        result_claim_record: '',
        result_claim_type_ck1: false,
        result_claim_type_ck2: false,
        result_claim_type_ck3: false,
        result_claim_type_ck3_text: '',
        result_claim_content: '',

        check_claim: '',

        student_claim_subject: '',
        student_claim_content: '',

        proj_situation_online_time: '',
        proj_situation_open_time: '',
        proj_situation_student_count: '',
        proj_situation_social: '',

        net_claim_content: '',
        net_claim_count: '',

        sys_claim_computer: '',
        sys_claim_other: '',
        sys_claim_mobile: '',

        not_sys_claim_plugin: '',
        not_sys_claim_plugin_name: '',
        not_sys_claim_plugin_size: '',
        not_sys_claim_plugin_link: '',
        not_sys_claim_content: '',

        user_hardware_claim_computer: '',
        user_hardware_claim_other: '',

        user_special_claim_hardware: '',
        user_special_claim_other: '',

        net_safe_claim: '',

        frame_content: '',
        frame_file: '',

        tech_goal_dev: '',
        tech_goal_tool: '',
        tech_goal_level: '',

        platform_lang: '',
        platform_tool: '',
        platform_db: '',

        feature_design: '',
        feature_tech: '',
        feature_appraise: '',
        feature_more: '',

        intellectual_register: '',
        intellectual_name: '',
        intellectual_same: '',
        intellectual_username: '',
        intellectual_power: '',
        intellectual_no: '',
        online_support: '',
        service_plan: '',
        promise_file: '',
        materials_file: ''
      },
      courseWareList: [],
      courseWareCount: 0,
      classCommentWindow: {},
      classDiscussWindow: {},
      classShowGradeWindow: {},
      collectInfo: true,
      commentInfo: {
        experiment_id: this.$route.query.id,
        userprofile_id: this.$store.state.userInfo.profile_id,
        grade: ''
      },
      star: 0,
      queryInfo: {
        page: 1,
        size: 10
      },
      audit_status: '',
      userList: [],
      commentType: true,
      studentPersonList: [],
      gradeTableData: [],
      gradeTableDataCount: 0,
      queryGradeInfo: {
        page: 1,
        size: 10,
        experiment_id: this.$route.query.id,
        expJoinType: 0
      },
      experimentGrade: {},
      classShowDetailWindow: {},
      tableStepData: []
    }
  },
  // 计算属性
  computed: {
    localUser() {
      return this.$store.state.userInfo
    },

    pageGradeInfo() {
      return {
        page: this.queryGradeInfo.page,
        all: Math.ceil(this.gradeTableDataCount / this.queryGradeInfo.size),
        totalData: this.gradeTableDataCount
      }
    }
  },
  methods: {
    formatVideoPath(briefVideo, briefResource) {
      if (briefResource && briefResource.status === 3) {
        return '/static/mp4/sd/' + briefResource.newSourceDIR + '/' + briefResource.newSourceID + '.mp4'
      } else {
        return briefVideo.substr(0, briefVideo.length)
      }
    },
    encryptDes (word) {
      const key = CryptoJs.enc.Utf8.parse('1234567890ABCDEF')
      const srcs = CryptoJs.enc.Utf8.parse(word)
      const encrypted = CryptoJs.AES.encrypt(srcs, key, {
        mode: CryptoJs.mode.ECB,
        padding: CryptoJs.pad.Pkcs7
      })
      return encrypted.toString()
    },
    decryptDes (word) {
      const key = CryptoJs.enc.Utf8.parse('1234567890ABCDEF')
      const decrypt = CryptoJs.AES.decrypt(word, key, {
        mode: CryptoJs.mode.ECB,
        padding: CryptoJs.pad.Pkcs7
      })
      return CryptoJs.enc.Utf8.stringify(decrypt).toString()
    },
    getUrlKey(name) {
      const url = window.location.href
      const dzUrl = url.split('#')[0]
      if (dzUrl.split('?').length <= 1) {
        return ''
      }
      const csArr = dzUrl.split('?')[1].split('&')
      const cs = {}
      for (let i = 0; i < csArr.length; i++) {
        cs[csArr[i].split('=')[0]] = csArr[i].split('=')[1]
      }
      return cs[name]
    },

    async viewDetail(item) {
      item.startTime = item.startTime.replace('T', ' ')
      item.endTime = item.endTime.replace('T', ' ')
      this.experimentGrade = item
      this.classShowDetailWindow = {
        visibility: 'visible'
      }
      const params = {
        page: 1,
        size: 10000,
        experimentGrade_id: item.id
      }

      await this.$http.get('/allowany/experimentstep/', {
        params: params
      }).then((data) => {
        this.tableStepData = data.results
      }).catch(() => {
        this.$layer.msg('获取成绩信息失败！')
      })
    },
    toViewScore() {
      this.classShowGradeWindow = {
        visibility: 'visible'
      }
    },
    async getGradeInfo() {
      await this.$http.get('/allowany/experimentgrade/', {
        params: this.queryGradeInfo
      }).then((data) => {
        this.gradeTableData = data.results
        this.gradeTableDataCount = data.count
      }).catch(() => {
        this.$layer.msg('获取成绩信息失败！')
      })
    },
    updateMenuSelected() {
      const url = window.location.href
      const arrUrl = url.split('//')
      const start = arrUrl[1].indexOf('/')
      let relUrl = arrUrl[1].substring(start)

      if (relUrl.indexOf('?') !== -1) {
        relUrl = relUrl.split('?')[0]
      }
      relUrl = relUrl.replace('#', '')
      this.menuSelected = relUrl
    },

    formatExpLevel(value) {
      return value ? this.$store.state.dict_exp_level[value] : '--'
    },
    changeToggleType(index) {
      this.courseWareList[index].showWindow = !this.courseWareList[index].showWindow
    },
    showCommentWindow() {
      this.classCommentWindow = {
        visibility: 'visible'
      }
    },
    hideCommentWindow() {
      this.classCommentWindow = {
        visibility: 'hidden'
      }
    },
    showDiscussWindow() {
      if (!this.$store.state.userInfo.profile_id) {
        this.$router.push('/login')
        return
      }
      if (this.userList.indexOf(this.$store.state.userInfo.profile_id) < 0) {
        this.classDiscussWindow = {
          visibility: 'visible'
        }
      } else {
        this.$layer.msg('您已经评论过了！')
      }
    },
    hideDiscussWindow() {
      this.star = 0
      this.commentInfo.grade = ''
      this.classDiscussWindow = {
        visibility: 'hidden'
      }
    },
    hoverStars(index) {
      this.star = index + 1
      this.commentInfo.grade = this.star
    },
    // 将当前用户添加进实验
    async addPerson() {
      if (!this.$store.state.userInfo.profile_id) {
        await this.$router.push('/login')
        return
      }

      const params = {
        experiment_id: this.$route.query.id,
        userprofile_id: this.$store.state.userInfo.profile_id,
        join_type: 0
      }

      await this.$http.get('/allowany/experimentstudent/', {
        params: params
      }).then(async (data) => {
        if (data.results.length > 0) {
          if (data.results[0].audit_status === 0) {
            this.$layer.msg('等待审核中，请勿重复申请！')
          } else {
            // 跳转链接
            await this.toUrl(data.results[0].id)
            await this.addLog()
          }
        } else {
          await this.$http.post('/experimentstudent_save/', {
            experiment_id: this.$route.query.id,
            userprofile_id: this.$store.state.userInfo.profile_id,
            audit_status: this.formInfo.isTeacherCheck ? 0 : 1,
            is_select: '0',
            expJoinType: '0'
          }).then(async (data) => {
            if (data.code === '200') {
              this.audit_status = data.audit_status
              if (data.audit_status === 0) {
                this.$layer.msg('已提交申请,等待审核中！')
              } else {
                // 跳转链接
                await this.toUrl(data.id)
                await this.addLog()
              }
            } else {
              this.$layer.msg('加入实验失败！')
            }
          }).catch(() => {
            this.$layer.msg('加入实验失败！')
          })
        }
      }).catch(() => {
        this.$layer.msg('操作失败！')
      })
    },
    // 手机端点击开始实验将当前用户添加进实验
    async mobileAddPerson() {
      if (!this.$store.state.userInfo.profile_id) {
        await this.$router.push('/login')
        return
      }

      const params = {
        experiment_id: this.$route.query.id,
        userprofile_id: this.$store.state.userInfo.profile_id,
        join_type: 0
      }

      await this.$http.get('/allowany/experimentstudent/', {
        params: params
      }).then(async (data) => {
        if (data.results.length > 0) {
          if (data.results[0].audit_status === 0) {
            this.$layer.msg('等待审核中，请勿重复申请！')
          } else {
            this.$layer.msg('移动端不支持虚拟仿真实验，请到WEB端进行实验')
            await this.addLog()
          }
        } else {
          await this.$http.post('/experimentstudent_save/', {
            experiment_id: this.$route.query.id,
            userprofile_id: this.$store.state.userInfo.profile_id,
            audit_status: this.formInfo.isTeacherCheck ? 0 : 1,
            is_select: '0',
            expJoinType: '0'
          }).then(async (data) => {
            if (data.code === '200') {
              this.audit_status = data.audit_status
              if (data.audit_status === 0) {
                this.$layer.msg('已提交申请,等待审核中！')
              } else {
                // 跳转链接
                this.$layer.msg('移动端不支持虚拟仿真实验，请到WEB端进行实验')
                await this.addLog()
              }
            } else {
              this.$layer.msg('加入实验失败！')
            }
          }).catch(() => {
            this.$layer.msg('加入实验失败！')
          })
        }
      }).catch(() => {
        this.$layer.msg('操作失败！')
      })
    },
    async toUrl(experimentStudentId) {
      if (this.formInfo.url) {
        await this.$http.post('/gen_ticket/', {
          user_id: this.$store.state.userInfo.profile_id,
          app_id: this.formInfo.id,
          username: this.$store.state.userInfo.user_name,
          experiment_student_id: experimentStudentId,
          join_type: 0
        }).then(async (data) => {
          if (data.code === '200') {
            if (this.formInfo.url) {
              if (this.formInfo.url.indexOf('?') !== -1) {
                window.open(this.formInfo.url + '&ticket=' + data.ticket)
              } else {
                window.open(this.formInfo.url + '?ticket=' + data.ticket)
              }
            } else {
              this.$layer.msg('实验路径配置错误，请联系管理员！')
            }
          }
        })
      }
    },
    // 发表评论
    async toComment() {
      if (this.commentInfo.grade === '') {
        this.$layer.msg('请选择评分！')
      }
      this.commentInfo.content = ''
      await this.$http.post('/experimentappraise_save/', this.commentInfo).then((data) => {
        if (data.code === '200') {
          this.commentType = false
          this.getExperimentInfo()
          this.getAppraiseInfo()
          this.hideDiscussWindow()
        } else {
          this.$layer.msg(data.msg)
        }
      }).catch(() => {
        this.$layer.msg('获取评价信息失败！')
      })
    },
    // 获取评论信息
    async getAppraiseInfo() {
      await this.$http.get('/allowany/experimentappraise/', {
        params: {
          experiment_id: this.$route.query.id
        }
      }).then((data) => {
        this.commentData = data.results
        this.commentDataCount = data.count
        this.userList = this.commentData.map(item => item.userprofile_id)
      }).catch(() => {
        this.$layer.msg('获取评价信息失败！')
      })
    },
    // 查询当前用户是否评论过
    async getUserAppraiseInfo() {
      await this.$http.get('/allowany/experimentappraise/', {
        params: {
          experiment_id: this.$route.query.id,
          userprofile_id: this.$store.state.userInfo.profile_id
        }
      }).then((data) => {
        if (data.results.length > 0) {
          if (this.$store.state.userInfo.profile_id === data.results[0].userprofile_id) {
            this.commentType = false
          }
        }
      }).catch(() => {
        this.$layer.msg('获取评价信息失败！')
      })
    },

    // 收藏
    async toCollect() {
      if (!this.$store.state.userInfo.profile_id) {
        this.$router.push('/login')
        return
      }
      const params = {
        experiment_id: this.$route.query.id,
        userprofile_id: this.$store.state.userInfo.profile_id
      }
      if (this.collectInfo) {
        this.collectInfo = false
        await this.$http.post('/experimentcollect_save/', params).then((data) => {
          if (data.code === '200') {
            this.$layer.msg('添加收藏成功！')
          } else {
            this.$layer.msg('添加收藏失败！')
          }
        }).catch(() => {
          this.$layer.msg('添加收藏失败！')
        })
      } else {
        this.$layer.msg('已收藏！')
      }
    },
    // 获取收藏状态
    async getCollect() {
      const itemInfo = {
        experiment_id: this.$route.query.id,
        userprofile_id: this.$store.state.userInfo.profile_id,
        page: 1,
        size: 10000
      }
      await this.$http.get('/allowany/experimentcollect/', {
        params: itemInfo
      }).then((data) => {
        if (data.results.length > 0) {
          if (itemInfo.userprofile_id === data.results[0].userprofile_id) {
            this.collectInfo = false
          }
        }
      })
    },
    // 获取主要成员
    async getUseMember() {
      await this.$http.get('/allowany/experimentmember/', {
        params: {
          page: 1,
          size: 100,
          experiment_id: this.$route.query.id
        }
      }).then((data) => {
        this.mainData = []
        this.otherData = []
        data.results.forEach(element => {
          if (element.is_main) {
            this.mainData.push(element)
          } else {
            this.otherData.push(element)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取课件信息
    async queryCourseWare() {
      await this.$http.get('/allowany/experimentcourseware/', {
        params: {
          experiment_id: this.$route.query.id
        }
      }).then((data) => {
        data.results.forEach(item => {
          item.showWindow = true
        })
        this.courseWareList = data.results
        this.courseWareCount = data.count
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('查询课件失败！')
      })
    },
    // 获取实验信息
    async getExperimentInfo() {
      const url = '/allowany/experiment/' + this.$route.query.id + '/'
      await this.$http.get(url).then((data) => {
        this.formInfo = data
        this.formInfo.frame_file = data.frame_file ? JSON.parse(data.frame_file) : []
        this.formInfo.theory_point = data.theory_point ? JSON.parse(data.theory_point) : []
        this.formInfo.online_support = data.online_support ? JSON.parse(data.online_support) : ''
        this.formInfo.service_plan = data.service_plan ? JSON.parse(data.service_plan) : ''
        this.formInfo.promise_file = data.promise_file ? JSON.parse(data.promise_file) : ''
        this.formInfo.materials_file = data.materials_file ? JSON.parse(data.materials_file) : ''
        this.formInfo.necessity = data.necessity ? JSON.parse(data.necessity) : {}
        this.queryCourseWare()
      }).catch((error) => {
        console.log(error)
      })
    },
    async addLog() {
      await this.$http.post('/user_log/', {
        userprofile_id: this.$store.state.userInfo.profile_id,
        category: 2,
        content: `实验名称：${this.formInfo.title}`
      }).then(async (data) => {
      }).catch(() => {
        this.$layer.msg('添加日志失败！')
      })
    },

    pageGradeCallback(data) {
      this.queryGradeInfo.page = data
      this.getGradeInfo()
    },
    // 课件分页courseWareList
    pageCourseCallback(data) {
      this.queryInfo.page = data
      this.queryCourseWare()
    },
    async viewCount() {
      await this.$http.post('/experiment_view_count/', {
        id: this.$route.query.id
      }).then((data) => {

      }).catch((error) => {
        console.log(error)
      })
    }

  },
  mounted() {
    this.viewCount()
    this.updateMenuSelected()
    this.getAppraiseInfo()
    this.getUserAppraiseInfo()
    this.getGradeInfo()
    if (this.$store.state.userInfo.profile_id) {
      this.getCollect()
    }
    this.getUseMember()
    this.getExperimentInfo()
  },
  async created() {
    this.params.id = this.getUrlKey('id')
    this.params.ticket = this.getUrlKey('ticket')
    if (!this.params.id) {
      this.$router.push('/error?msg=参数错误')
    }
    this.params.id = parseInt(this.params.id)
    // 专家 带ticket登陆
    if (this.params.ticket && !this.$store.state.userInfo.profile_id) {
      const relTicketObj = JSON.parse(this.decryptDes(decodeURIComponent(this.params.ticket)))

      // 登录方法
      await this.$http.post('/api-token-auth/', {
        username: relTicketObj.username,
        password: relTicketObj.password
      }).then(async (data) => {
        if (!data.token) {
          console.log('专家账号或密码输入错误！')
          window.localStorage.clear()
        } else {
          console.log('专家登陆成功！')
          window.localStorage.clear()
          this.$store.commit('setToken', data.token)
          await this.$http.post('/login_user/', {}).then(async (data) => {
            console.log('专家获取用户信息成功！')
            this.$store.commit('setUserInfo', data)
          }).catch(() => {
            console.log('专家获取用户信息失败！')
          })
        }
      }).catch(() => {
        console.log('专家账号或密码输入错误！')
      })
    }

    if (this.$store.state.userInfo.profile_id) {
      const params = {
        experiment_id: this.$route.query.id,
        userprofile_id: this.$store.state.userInfo.profile_id,
        join_type: 0
      }
      await this.$http.get('/allowany/experimentstudent/', {
        params: params
      }).then((data) => {
        if (data.results.length) {
          this.audit_status = data.results[0].audit_status
        }
      }).catch(() => {
        this.$layer.msg('获取团队成员信息失败！')
      })
    }
  }
}
</script>
<style scoped src="../../../assets/css/dialog.css"></style>
<style scoped src="../../../assets/css/common.css"></style>

<style scoped src="../../../assets/css/form.css"></style>
<style scoped src="../../../assets/css/project-detail.css"></style>
<style scoped src="../../../assets/css/table.css"></style>

<style scoped src="../../../assets/css/pagination.css"></style>
<style lang="less" scoped>
.list td {
  position: relative;
  overflow: hidden;
}

.person_symbol {
  position: absolute;
  left: -17px;
  top: 4px;
  background: #ff2424;
  color: #fff;
  width: 70px;
  text-align: center;
  font-size: 12px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}

#center {
  background: #fff;
}

.content-span {
  span {
    position: relative;

    &::after {
      content: ",";
      display: block;
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
}

.form_overlay {
  z-index: 471 !important;
}

.btn-publish-bg {
  padding: 0 20px;
  border-radius: 5px;
  height: 40px;
  line-height: 40px;
  border: none;
  font-size: 16px;
  color: #fff;
  float: right;
  cursor: pointer;
  outline: none;
  background: #aaa;
}

.NumCount {
  display: inline-block;
  text-align: center;
  width: 40px;
  border-bottom: 1px solid #999;
}

.teachItem {
  p {
    font-weight: 600;
  }

  .link {
    color: #0b80ff;
    margin: 10px 0;
    display: block;
  }
}

.teachEdit {
  .m-r {
    color: #333333;
    font-weight: 500;
    display: inline-block;
    width: 150px;

    input {
      position: relative;
      top: -1px;
      margin-right: 7px;
    }
  }

  .file {
    color: #0b80ff;
    display: block;

    .del {
      margin-left: 10px;
      font-size: 22px;
      color: #c7254e;
      cursor: pointer;
      margin: 0;
      background: transparent;
      top: 3px;
      position: relative;
    }
  }

  .upload {
    display: block;
    text-align: center;
    width: 55px;
    line-height: 30px;
    background: #f19830;
    color: #fff;
    cursor: pointer;
  }
}

.warn {
  p {
    font-size: 12px;
    color: #df3d3e;
  }

  span {
    font-size: 12px;
    color: #337ab7;
    cursor: pointer;
  }
}

.part-content {
  .part-new-table {
    margin: 10px 0;
    border: 1px solid #ebebeb;
    width: 100%;
    max-width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    background-color: transparent;

    tr th {
      background-color: #f8faff;
      color: #999;
      font-weight: normal;
    }
  }

  .part-new-table tr th,
  .part-new-table tr td {
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: middle;
    border: 1px solid #ebebeb;
    text-align: center;
  }
}

.signPic {
  max-height: 20px;
  max-width: 120px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -3px;
  margin-right: 25px;
}

#center {
  padding-top: 0 !important;
}

.mbox .detail-wrap .detail-intro {
  height: 70px;
}

.mbox .detail-wrap .btn-wrap-evaluate {
  margin-top: 20px;
}

.mbox .detail-wrap .btns-wrap .btn-view {
  background: orange;
}

#uList-table {
  padding-top: 40px;
}

.form_panel_item {
  width: 1200px;
  max-width: none;
  margin: 0;
  transform: translate(-50%, -50%);
}

.f_list .l_header th {
  padding: 15px 0;
}

.form_title {
  position: relative;
  margin-bottom: 20px;
}

.form_title span {
  position: absolute;
  right: 0;
  top: 0;
  background: #ff8383 repeat scroll 0 0;
  color: #ff8383;
  cursor: pointer;
  height: 30px;
  line-height: 28px;
  text-align: center;
  width: 30px;
  font-size: 24px;
  border-radius: 3px;
  overflow: hidden;
}

.form_title span::before {
  content: "×";
  display: block;
  width: 30px;
  height: 30px;
  font-family: 宋体;
  color: rgb(255, 255, 255);
}

.experiment_text {
  margin-bottom: 20px;
}

.experiment_text p {
  line-height: 3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.experiment_text p span {
  flex: 1;
}
</style>
